import * as React from 'react';
import * as Glob from '../Globale';
import {NavMain} from "../layout/";
import {ProfileComponent} from "../components/ProfileComponent";

export class Header extends React.Component<Glob.IGlobaleProps, {}> {
    public render() {
        return <div>
            <div id="kt_header_mobile" className="kt-header-mobile  kt-header-mobile--fixed ">
                <div className="kt-header-mobile__logo">
                    <a href="index.html"><img alt="" src="images/logoInAR.png"/></a>
                </div>
                <div className="kt-header-mobile__toolbar">
                    <button className="kt-header-mobile__toggler kt-header-mobile__toggler--left"
                            id="kt_aside_mobile_toggler"><span/></button>
                    <button className="kt-header-mobile__toggler" id="kt_header_mobile_toggler">
                        <span/></button>
                    <button className="kt-header-mobile__topbar-toggler"
                            id="kt_header_mobile_topbar_toggler"><i className="flaticon-more"/>
                    </button>
                </div>
            </div>

            <div id="kt_header" className="kt-header kt-grid__item  kt-header--fixed ">
                <button className="kt-header-menu-wrapper-close"
                        id="kt_header_menu_mobile_close_btn"><i
                    className="la la-close"/></button>
                <div className="kt-header-menu-wrapper aside-header-menu-dark"
                     id="kt_header_menu_wrapper">
                    <div id="kt_header_menu"
                         className="kt-header-menu kt-header-menu-mobile aside-header-menu-dark kt-header-menu--layout-default ">
                        <ul className="kt-menu__nav kt-menu__nav--submenu-arrow "
                            id="menuPadre">
                            <NavMain {...this.props as any} />
                        </ul>
                    </div>
                </div>
                <ProfileComponent/>
            </div>
        </div>
    }
}



// WEBPACK FOOTER //
// ./src/layout/Header.tsx